<template>
  <section class="container-fluid p-0 headerArea">
    <div class="containerBox">
      <div class="row m-0 headerWrapper justify-content-center align-items-center">
        <div class="col-8 pr-0">
          <!--  <router-link to="/" ><img src="../assets/images/logo.png" alt="logo" width="120px" /></router-link> -->
          <a href="/"><img src="../assets/images/careai-logo.svg" alt="Care.ai" width="120" /></a>
          <div class="statistics">
            <!--Date & Time :&nbsp;--><span>{{ currentDateTime }}</span>
          </div>
        </div>
        <div class="col text-right row m-0">
          <div class="menuItemsWrapper row col align-items-center justify-content-end"></div>
          <div class="dropdown show">
            <ul class="navbar-nav d-none d-md-block">
              <li v-if="!$auth.isAuthenticated && !$auth.loading" class="nav-item">
                <button id="qsLoginBtn" class="btn btn-primary btn-margin" @click.prevent="login">
                  Login
                </button>
              </li>
              <li class="nav-item dropdown" v-if="$auth.isAuthenticated">
                <a class="nav-link dropdown-toggle" href="#" id="profileDropDown" data-toggle="dropdown">
                  <img :src="$auth.user.picture" alt="User's profile picture"
                    class="dropdown-toggle userMenuDropDown avatarStyle" width="50" />
                  <span class="username">{{ $auth.user.name }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-left userDropdownMenu ">
                  <div class="dropdown-header">{{ $auth.user.name }}</div>
                  <ul class="navbar">
                    <li class="dropdown-container-box ">
                      <router-link to="/caching" class="dropdown-item pl-0"><img src="../assets/images/licenseIcon.svg"
                          alt="Caching" />Caching
                      </router-link>
                    </li>
                    <li>
                      <span :class="isActiveDevices == true ? 'caret-down' : 'caret'"
                        @click.stop="toggleDevices">Devices</span>
                      <div v-show="isActiveDevices">
                        <ul>
                          <li>
                            <router-link to="/devices" class="dropdown-item ">
                              <img src="../assets/images/lists.svg" alt="Devices" />Lists
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/devicesjobs" class="dropdown-item">
                              <img src="../assets/images/jobs.svg" alt="Sensor Jobs" />
                              Jobs
                            </router-link>
                          </li>
                          <li v-if="bmEnabled">
                            <router-link to="/bed-manager" class="dropdown-item">
                              <img src="../assets/images/bed-mng.svg" alt="Manage Beds" />
                              Bed Manager
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li><span :class="isActiveIAM == true ? 'caret-down' : 'caret'" @click.stop="toggleIAM">IAM</span>
                      <div v-show="isActiveIAM">
                        <ul class="mt-1">
                          <li>
                            <router-link to="/activities" class="dropdown-item"><img src="../assets/images/roles.svg"
                                                                                alt="Roles" />
                              Activities
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/roles" class="dropdown-item"><img src="../assets/images/roles.svg"
                                alt="Roles" />
                              Roles
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/saml" class="dropdown-item"><img src="../assets/images/group-mapping.svg" alt="Saml" />SAML
                              Group Mapping
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/authConnections" class="dropdown-item"><img src="../assets/images/connections.svg"
                                alt="Saml" />Auth Connections
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/users" class="dropdown-item"><img src="../assets/images/usersIcon.svg"
                                alt="Users" />User List
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="dropdown-container-box ">
                      <router-link to="/location" class="dropdown-item pl-0"><img src="../assets/images/location.svg"
                          alt="Location" />Location
                      </router-link>
                    </li>
                    <li class="dropdown-container-box ">
                      <router-link to="/releasenotes" class="dropdown-item pl-0"><img src="../assets/images/timesheet.svg"
                          alt="Release Notes" />Release Notes
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/tenants" class="dropdown-item pl-0"><img src="../assets/images/tenents-icon.svg"
                          alt="Tenants" /> Tenants
                      </router-link>
                    </li>
                    <li><span :class="isActiveCL == true ? 'caret-down' : 'caret'" @click.stop="toggleCL">Tools</span>
                      <div v-show="isActiveCL">
                        <ul>
                          <li>
                            <router-link to="/callquality" class="dropdown-item mt-1 mb-1"><img
                                src="../assets/images/call-quality.svg" alt="Call Quality" />Call Quality
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/devicelogs" class="dropdown-item mt-1 mb-1"><img
                                src="../assets/images/device-logs.svg" alt="Device Logs" />Call Tracking
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/deviceuptimelogs" class="dropdown-item mt-1 mb-1"><img
                                src="../assets/images/up-time-logs.svg" alt="Device Logs" />Device Uptime Logs
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/devicestatusreports" class="dropdown-item mt-1 mb-1"><img src="../assets/images/device-status-reports.svg"
                                                                                                        alt="Device Status Reports" />Device Status Reports
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/patient-tracking" class="dropdown-item mt-1 mb-1"><img src="../assets/images/patient-tracking.svg"
                                                                                                     alt="Device Logs" />Patient Tracking
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/gateway/dashboard" class="dropdown-item">
                              <img style="filter: invert(46%) sepia(75%) saturate(477%) hue-rotate(145deg) brightness(106%) contrast(87%);" src="../assets/images/gateway.svg" alt="Gateway" />
                              Gateway
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <span :class="isActiveVN == true ? 'caret-down' : 'caret'" @click.stop="toggleVN">Virtual Care & Monitoring</span>
                      <div v-show="isActiveVN">
                        <ul>
                          <li>
                            <router-link to="/virtualnursing" class="dropdown-item mt-1 mb-1"><img
                                src="../assets/images/configuration.svg" alt="Configure Tasks" />Configure Tasks
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/devicemessages" class="dropdown-item mt-1 mb-1"><img
                              src="../assets/images/device-message-configuration.svg"
                              alt="Configure VM Tasks" />Configure VM tasks
                          </router-link>
                          </li>
                          <li>
                            <router-link to="/virtual-visit-participants" class="dropdown-item ">
                              <img src="../assets/images/call-quality.svg" alt="Devices" />View Active Participants
                            </router-link>
                          </li>
                          <li>
                            <router-link to="/media-node-config" class="dropdown-item mt-1 mb-1"><img src="../assets/images/config-fhir_1.svg"
                                                                                                      alt="Configure Media Node" />Configure Media Node
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <!-- <li>
                      <span :class="isActiveVM == true ? 'caret-down' : 'caret'" @click.stop="toggleVM">Virtual
                        Monitoring</span>
                      <ul v-show="isActiveVM">
                        <li>
                          <router-link to="/devicemessages" class="dropdown-item mt-1 mb-1"><img
                              src="../assets/images/device-message-configuration.svg"
                              alt="Devices Messages settings" />Device Message Configuration
                          </router-link>
                        </li>
                      </ul>
                    </li> -->
                    <li><a id="qsLogoutBtn" href="#" class="dropdown-item" @click.prevent="logout">
                        <!-- <img src="../assets/images/logout.svg" alt="Release Notes" /> -->
                        <font-awesome-icon class="mr-3" icon="power-off"
                          style="margin-right:5px !important; width:15px !important" />
                        Log out
                      </a></li>
                  </ul>
                </div>
              </li>
            </ul>

            <ul class="navbar-nav d-md-none" v-if="!$auth.isAuthenticated && !$auth.loading">
              <button id="qsLoginBtn" class="btn btn-primary btn-block" @click="login">
                Log in
              </button>
            </ul>

            <ul id="mobileAuthNavBar" class="navbar-nav d-md-none d-flex" v-if="$auth.isAuthenticated">
              <li class="nav-item">
                <span class="user-info">
                  <img :src="$auth.user.picture" alt="User's profile picture"
                    class="nav-user-profile d-inline-block rounded-circle mr-3" width="50" />
                  <h6 class="d-inline-block">{{ $auth.user.name }}</h6>
                </span>
              </li>
              <!--  <li>
              <font-awesome-icon icon="user" class="mr-3" />
              <router-link to="/profile">Profile</router-link>
            </li> -->

              <li>
                <font-awesome-icon icon="power-off" class="mr-3" />
                <a id="qsLogoutBtn" href="#" class @click.prevent="logout">Log out</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from "moment";

export default {
  name: "NavBar",
  computed: {
    currentPage() {
      return this.$router.path;
    },
    bmEnabled() {
      return this.userPermissions.some((perm) => this.BM_PERMISSION.includes(perm));
    }
  },
  data() {
    return {
      BM_PERMISSION: ['manage:devices', 'app:mgr'],
      permissionsCheck: null,
      currentDateTime: moment(new Date()).format("MM/DD/YYYY hh:mm:ss a").replace(",", ""),
      userCachingAccess: false,
      userPermissions: [],
      isActiveVN: false,
      isActiveIAM: false,
      isActiveCL: false,
      isActiveVM: false,
      isActiveDevices: false,
      isActiveVV: false
    };
  },
  created() {
    this.interval = setInterval(
      function () {
        this.updateTime();
      }.bind(this),
      1000
    );
  },
  updated() {
    this.showCaching();
  },
  methods: {
    async login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout();
      window.location.href = window.location.origin + '/log-out';
      //this.$router.push({ path: "/" });
    },
    toggleVN() {
      this.isActiveVN = !this.isActiveVN;
      this.isActiveCL = false;
      this.isActiveVM = false;
      this.isActiveDevices = false;
      this.isActiveIAM = false;
      this.isActiveVV = false;
    },
    toggleCL() {
      this.isActiveCL = !this.isActiveCL;
      this.isActiveVN = false;
      this.isActiveVM = false;
      this.isActiveDevices = false;
      this.isActiveIAM = false;
      this.isActiveVV = false;
    },
    toggleDevices() {
      this.isActiveDevices = !this.isActiveDevices;
      this.isActiveCL = false;
      this.isActiveVM = false;
      this.isActiveVN = false;
      this.isActiveIAM = false;
      this.isActiveVV = false;
    },
    toggleIAM() {
      this.isActiveIAM = !this.isActiveIAM;
      this.isActiveCL = false;
      this.isActiveVM = false;
      this.isActiveDevices = false;
      this.isActiveVN = false;
      this.isActiveVV = false;
    },
    toggleVM() {
      this.isActiveVM = !this.isActiveVM;
      this.isActiveCL = false;
      this.isActiveVN = false;
      this.isActiveDevices = false;
      this.isActiveIAM = false;
      this.isActiveVV = false;
    },
    toggleVV() {
      this.isActiveVV = !this.isActiveVV;
      this.isActiveCL = false;
      this.isActiveVM = false;
      this.isActiveVN = false;
      this.isActiveDevices = false;
      this.isActiveIAM = false;
    },
    async updateTime() {
      this.currentDateTime = moment(new Date()).format("MM/DD/YYYY hh:mm:ss a").replace(",", "");
    },
    async showTraining() {
      if (this.$auth.isAuthenticated) {
        const claims = await this.$auth.getIdTokenClaims();
        const userPermissions = claims["https://care.ai/permissions"];
        if (
          userPermissions &&
          userPermissions.length > 0 &&
          userPermissions.indexOf("update:annotations") >= 0
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    async showCaching() {
      if (this.$auth.isAuthenticated) {
        const claims = await this.$auth.getIdTokenClaims();
        const userPermissions = claims["https://care.ai/permissions"];
        if (
          userPermissions &&
          userPermissions.length > 0 &&
          userPermissions.indexOf("allow:super-admin") >= 0
        ) {
          return (this.userCachingAccess = true);
        }
        return (this.userCachingAccess = false);
      }
      return (this.userCachingAccess = false);
    }, 
    async getPermissions() {
      if (this.$auth && this.$auth.getIdTokenClaims) {
        try {
          this.$auth.getIdTokenClaims().then((res) => {
            if (res && res['https://care.ai/permissions']) {
              this.userPermissions = res['https://care.ai/permissions'];
              clearInterval(this.permissionsCheck);
            }
            
          });
        } catch {}
      }
    }
  },
  mounted() {
    this.$root.$on("message from home", (arg) => {
      this.currentDateTime = moment(new Date()).format("MM/DD/YYYY hh:mm:ss a").replace(",", "");
      //this.currentDateTime = (new Date()).toLocaleString().replace(',','')
    });

    this.permissionsCheck = setInterval(() => {
      this.getPermissions();
    }, 500);
  }
};
</script>

<style>
.caret::before {
  content: "\25B6";
  display: inline-block;
  margin-right: 7px;
  font-size: 10px;
  cursor: pointer;
  position: relative;
  top: -1px;
  color: #6a6a6a;
}

.caret-down::before {
  -ms-transform: rotate(90deg);
  /* IE 9 */
  -webkit-transform: rotate(90deg);
  /* Safari */
  transform: rotate(90deg);
  cursor: pointer;
  content: "\25B6";
  display: inline-block;
  margin-right: 7px;
  font-size: 10px;
  color: #6a6a6a;
}

.navbar {
  background: white !important;
  flex-direction: column;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  padding: 0px 0px !important;
}

.dropdown-container-box {
  margin-bottom: 10px;
  color: black
}

.navbar li {
  list-style: none;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
  border-bottom: 1px solid #e5f0f2;
  color: #484848 !important;
  cursor: pointer;
}

.navbar li ul li:last-child {
  border-bottom: none;
}

.navbar li ul {
  padding: 0 0 0 20px;
}

.navbar li ul li {
  padding: 0px;
}

/* .fixed-navbar{
  padding-top:0px;
  padding-bottom:0px;
}
.fixed-nav{
  position:fixed;
  width:100%;
}
#mobileAuthNavBar {
  min-height: 125px;
  justify-content: space-between;
} */
.headerArea {
  font-family: GTWalsheimPro-Regular !important;
}

.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px 0 0;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #484848;
  padding: 0;
  text-decoration: none;
}

.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  /* background: #f2fdff; */
}

.menuItemsWrapper {
  /* border-right: 1px solid #e5f0f2; */
  padding-right: 15px !important;
  margin-right: 15px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  position: relative;
  color: #484848;
}

.menuItem>a {
  color: #484848;
  text-decoration: none;
}

.menuItem>a::after {
  content: '';
  position: absolute;
  top: 45px;
  width: 0px;
  height: 3px;
  display: block;
  background: #f27778;
  transition: 500ms;
}

.menuItem>a:hover::after {
  width: calc(100% - 40px);
}

.router-link-exact-active {
  /* background-color: black !important; */
  color: #1dd8f6 !important;
  cursor: pointer !important;
  text-decoration: none !important;
}

.router-link-exact-active.router-link-active:after {
  content: '';
  position: absolute;
  top: 45px;
  width: calc(100% - 35px);
  height: 3px;
  background: #f27778;
  display: none;
}

.menuItem .router-link-exact-active>a,
.menuItem .router-link-exact-active>a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics>span {
  color: #484848;
  font-size: 16px;
  line-height: 1;
}

.avatarStyle {
  border-radius: 50px;
  border-style: none;
  height: 40px;
  width: 40px;
}

.navbar-nav .nav-link {
  color: #484848 !important;
  padding: 0 0 0.5rem 0;
  box-sizing: border-box;
  margin: 0 40px 0 0;
  font-weight: 400;
}


.username {
  padding-left: 10px;
  padding-right: 10px;
}

.dropdown,
.dropleft,
.dropright,
.dropup {
  position: relative;
  height: 40px;
  line-height: 40px;
}

.dropdown-toggle::after {
  position: absolute;
  top: 17px;
}

.nav-item.dropdown .dropdown-header {
  border-bottom: 1px solid #f1f1f1;
  color: #484848;
  padding: 0 15px;
  font-weight: 400;
  font-size: 16px;
}

.dropdown-item {
  color: #484848 !important;
  padding: 4px 20px;
}

.dropdown-menu {
  padding: 0px !important;

}

.nav-item.dropdown .dropdown-item {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  display: flex;
  align-items: center;
  padding: 0;
  background: transparent !important;
}

.nav-item.dropdown .dropdown-item:hover {
  color: #1dd8f6 !important;
}

.nav-item.dropdown .dropdown-item.router-link-exact-active,
.nav-item.dropdown .dropdown-item.router-link-active {
  color: #1dd8f6 !important;
}

.nav-item.dropdown .dropdown-item img {
  width: 15px;
  margin-right: 5px;
}

.dropdown-menu.dropdown-menu-left.userDropdownMenu.show {
  right: 10px;
  min-width: 300px;
  transform: translate3d(-40px, 41px, 0px)
}

@media (min-width: 1366px) and (max-width: 1700px) {

  /* .statistics {
    font-size: 16px;
    line-height: 15px;
  }
  .statistics span {
    font-size: 14px;
  } */
  .menuItem {
    display: flex;
    align-items: center;
    padding: 15px 15px 0 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #f1f1f1;
  }

  .menuItem>a:hover::after {
    width: calc(100% - 25px);
  }

  .router-link-exact-active.router-link-active:after {
    content: '';
    position: absolute;
    top: 45px;
    width: calc(100% - 25px);
    height: 3px;
    background: #f27778;
    display: none;
  }
}
</style>
